/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/Views/app/precisao/laborder/styled.ts
 * Papel: pagina do modulo legado
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */

import styled from 'styled-components'

export const Container = styled.div`
  .hideColum {
    display: none;
  }
`
